import { createSlice } from '@reduxjs/toolkit';
import { fetchQueries } from './actions';

const initialState = {
  list: [],
  meta: null,
  isLoading: false,
  error: null,
  hasLoaded: false,
  requestedComplaintTypeId: null,
};

const unwrapQueries = (payload) => {
  const body = payload?.data ?? payload;
  if (Array.isArray(body)) {
    return { list: body, meta: payload?.meta ?? payload?.pagination ?? null };
  }
  const list = body?.data ?? body?.results ?? body?.items ?? [];
  return {
    list: Array.isArray(list) ? list : [],
    meta: body?.meta ?? body?.pagination ?? payload?.meta ?? payload?.pagination ?? null,
  };
};

const errorMessage = (action) =>
  action.payload?.message ?? action.error?.message ?? 'Failed to fetch queries';

const queryManagementSlice = createSlice({
  name: 'queryManagement',
  initialState,
  reducers: {
    // Unused: nothing dispatches this helper.
    // clearQueryManagementError: (state) => {
    //   state.error = null;
    // },
    resetQueryManagementState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQueries.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.hasLoaded = false;
        state.list = [];
        state.requestedComplaintTypeId = action.meta.arg?.complaintTypeId ?? null;
      })
      .addCase(fetchQueries.fulfilled, (state, action) => {
        const requestedId = action.meta.arg?.complaintTypeId;
        if (
          state.requestedComplaintTypeId != null &&
          requestedId != null &&
          String(state.requestedComplaintTypeId) !== String(requestedId)
        ) {
          return;
        }
        const result = unwrapQueries(action.payload);
        state.isLoading = false;
        state.hasLoaded = true;
        state.list = result.list;
        state.meta = result.meta;
      })
      .addCase(fetchQueries.rejected, (state, action) => {
        if (action.meta.aborted) return;
        const requestedId = action.meta.arg?.complaintTypeId;
        if (
          state.requestedComplaintTypeId != null &&
          requestedId != null &&
          String(state.requestedComplaintTypeId) !== String(requestedId)
        ) {
          return;
        }
        state.isLoading = false;
        state.hasLoaded = true;
        state.error = errorMessage(action);
      });
  },
});

export const {
  // clearQueryManagementError,
  resetQueryManagementState,
} =
  queryManagementSlice.actions;
export default queryManagementSlice.reducer;
